export default __webpack_public_path__ + "static/media/logoBlack.a436807a.svg";